import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    Grid,
    MenuItem,
    Tooltip,
    IconButton,
    withStyles,
    Dialog, DialogActions,
    DialogContent, DialogContentText, TextField,
    DialogTitle
} from "@material-ui/core";
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { ArrowBack } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import { useErrorSnackbar } from "../components/errorsnackbarcontext";
import axios from 'axios';
import {
    IUserAdmin, IRole
} from "../types/types";
import { get, post, del, put} from "../fetchers/fetchers";
import SFIARPToolbar from '../components/toolbar';
import { API_URL } from "../env";


const useStyles = makeStyles({
    tableHeader: {
        backgroundColor: 'lightgrey',
    },
    tableHeaderCell: {
        textAlign: 'center',
    },
});

const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

interface IAdmintProps { }

const Admnin: FC<IAdmintProps> = () => {
    const classes = useStyles();
    const { showError } = useErrorSnackbar();

    const [users, setUsers] = useState<IUserAdmin[]>([]);
    const [roles, setRoles] = useState<IRole[]>([]);
    const [reloadUsers, setReloadUsers] = useState<boolean>(false)
    const [openUserAddDialog, setOpenUserAddDialog] = useState<boolean>(false);

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const handleClose = () => {
        setOpenUserAddDialog(false)
    }

    const handleOpen = () => {
        setOpenUserAddDialog(true)
    }

    const getUsers = async () => {
        return await get<IUserAdmin[]>(API_URL + "user/", undefined, (error) => {
            if (axios.isAxiosError(error) && error.response?.status === 401) {
                showError('Unauthorized request when fetching users! Contact your administrator.');
            }
        });
    }

    const getRoles = async () => {
        return await get<IRole[]>(API_URL + "role/");
    }

    const handleBack = () => {
        window.location.href = "/"
    }

    const updateRole = async (user_id: number, role_id: number) => {
        let payload = {
            user_id: user_id,
            role_id: role_id
        }
        return await post<any>(API_URL + "user/role/", payload)
    }

    const handleRoleChange = (user_id: number, event: React.ChangeEvent<{ value: unknown }>) => {
        const role_id = event.target.value as number;

        updateRole(user_id, role_id).then(() =>
            setReloadUsers(true)
        )
    };

    useEffect(() => {
        Promise.all([getUsers(), getRoles()]).then(([users, roles]) => {
            setUsers(users);
            setRoles(roles);
        });
    }, []);

    useEffect(() => {
        if (reloadUsers) {
            setReloadUsers(false)
            getUsers().then((users) => {
                setUsers(users)
            }
            )
        }
    }, [reloadUsers, setReloadUsers]
    )
    const handleCreateUser = () => {
        postCreateUser(username, password).then(() => {
            handleClose();
            setUsername('');
            setPassword('');
            setReloadUsers(true);
        });
    }
    const postCreateUser = async (email: string, password: string) => {
        const payload = {
            username: email,
            password: password
        }
        return await post<any>(API_URL + "user/register/", payload)
    }

    const delUser = async (user_id: number) => {
        return await del<any>(API_URL + "user/" + user_id )
    }

    const putUser = async (user: IUserAdmin) => {
        // copy user


        return await put<any>(API_URL + "user/", {id: user.id, email: user.email, is_active: true})
    }

    const handleRemoveUser = (user_id: number) => {
        delUser(user_id).then(() => {
            setReloadUsers(true);
        });
    }

    const handleEnable = (user: IUserAdmin) => {
        putUser(user).then(() => {
            setReloadUsers(true);
        })
    }

    const create_user_dialog = () => {
        return (
            <Dialog open={openUserAddDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add User</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Create new user
                        </Typography>
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="username"
                        label="Username"
                        type="text"
                        fullWidth
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        id="password"
                        label="Password"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleCreateUser} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <>
            <SFIARPToolbar title={"User management"}/>


        <Container>
            {create_user_dialog()}
            <Grid container spacing={3} xl={12} direction="row" style={{ padding: "20px", marginTop: "40px" }}>
                <Grid item xs={5} sm={3} md={2} lg={2}>
                    <div style={{ position: "sticky", top: "68px" }}>
                        <Tooltip title="Back" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleBack()} >
                                <ArrowBack />
                            </AddingButton>
                        </Tooltip>
                        <br />
                        <Tooltip title="Create new project" placement={'bottom-end'}>
                            <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }} onClick={prevState => handleOpen()} >
                                <AddIcon />
                            </AddingButton>
                        </Tooltip>
                    </div>
                </Grid>
                <Grid item xs={7} sm={9} md={9} lg={10} container spacing={3}>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableHeaderCell} >Email</TableCell>
                                    <TableCell className={classes.tableHeaderCell} >Role </TableCell>
                                    <TableCell className={classes.tableHeaderCell} > Action </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.map((user) => (
                                    <TableRow key={user.id}>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>
                                            <Select
                                                value={user.roles && user.roles[0]?.id || ''}
                                                onChange={(e) => handleRoleChange(user.id || -1, e)}
                                            >
                                                {roles.map(role => (
                                                    <MenuItem key={role.id} value={role.id}>
                                                        {role.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </TableCell>
                                        <TableCell>
                                            {user.is_active && <Button variant="outlined" size="small" onClick={prevState => handleRemoveUser(user.id|| -1)}>Disable</Button> }
                                            {!user.is_active && <Button variant="outlined" size="small" onClick={prevState => handleEnable(user)}>Enable</Button> }

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Container>
        </>

    );
}

export default Admnin;
